<template>
  <a-modal
    title="法人选择"
    :visible="isShow"
    @ok="handleOk"
    @cancel="handleCancel"
    :width="900"
    destroyOnClose>
    <Form :model="searchParasm" inline>
    <FormItem>
      <Input v-model="searchParasm.name" placeholder="用户姓名" clearable>请输入用户名</Input>
    </FormItem>
    <FormItem>
      <Input v-model="searchParasm.phone"
             placeholder="手机号"
             clearable>
      </Input>
    </FormItem>
    <!--查询按钮-->
    <FormItem>
      <Button icon="ios-search" shape="circle" @click="search">查询</Button>
    </FormItem>
  </Form>
    <Table border :columns="columns"  :data="tableData" :loading="loading"></Table>
    <div class="page-area">
      <Page
        :total="pageTotal"
        :page-size="pageLength"
        :current="pageOffset"
        @on-change="handlePageChange"
        show-total
        show-elevator
      />
    </div>







  </a-modal>

</template>

<script>
  import util from '@/libs/util.js'
    export default {
        name: "index",
      data(){
          return{
            isShow:false,
            searchParasm:{
              name:'',
              phone:''
            },
            id_jishi:0,
            currentid:0,
            columns: [
              {
                title: '选择',
                key: 'chose',
                width: 70,
                align: 'center',
                render: (h, params) => {
                  let id = params.row.id;
                  let flag = false;
                  if (this.currentid === id) {
                    flag = true
                  } else {
                    flag = false
                  }
                  let self = this
                  return h('div', [
                    h('Radio', {
                      props: {
                        value: flag
                      },
                      on: {
                        'on-change': () => {
                          self.currentid = id
                          this.id_jishi = params.row.id
                        }
                      }
                    })
                  ])
                }
              },
              {
                key: 'order',
                title: '序号',
                align: 'center',
                width:70
              },
              {
                key: 'name',
                title: '用户姓名',
                align: 'center',
                render: (h, params) => {
                  let isrealauthName
                  if (params.row.isrealauth != '1') {
                    isrealauthName = '未认证'
                  } else {
                    isrealauthName = params.row.name;
                  }
                  return h('div', [
                    h(
                      'span',
                      {
                        domProps: {
                          innerHTML: isrealauthName
                        },
                      },
                    ),
                  ])
                }
              },
              {
                key: 'phone',
                title: '手机号',
                align: 'center',
              },
              {
                key: 'isrealauth',
                title: '是否实名',
                align: 'center',
                width: 150,
                render: (h, params) => {
                  let isrealauthName
                  if (params.row.isrealauth == '2') {
                    isrealauthName = '待审核'

                  } else if (params.row.isrealauth == '1') {
                    isrealauthName = '已认证'
                  } else {
                    isrealauthName = '未认证'
                  }
                  return h('div', [
                    h(
                      'span',
                      {
                        domProps: {
                          innerHTML: isrealauthName
                        },
                      },
                    ),
                  ])
                }
              },
              {
                key: 'createTime',
                title: '创建时间',
                align: 'center',
                width:'250',
                render: (h, params) => {
                  return h('div', [
                    h(
                      'span',
                      {
                        domProps: {
                          innerHTML: this.formatTime(params.row.createTime)
                        },
                      },
                    ),
                  ])
                }
              },
            ],
            tableData: [],
            //分页参数
            pageLength: 10, // 每页条数
            pageTotal: 0, //总数
            pageOffset: 1, //页码
            loading: false,
            code:''
          }
      },
      methods:{
        formatTime (UTCDateString) {
          if (!UTCDateString) {
            return '-'
          }

          function formatFunc (str) {
            //格式化显示
            return str > 9 ? str : '0' + str
          }

          var date2 = new Date(UTCDateString) //这步是关键
          var year = date2.getFullYear()
          var mon = formatFunc(date2.getMonth() + 1)
          var day = formatFunc(date2.getDate())
          var hour = date2.getHours()
          var min = formatFunc(date2.getMinutes())
          var second = date2.getSeconds()
          var dateStr =
            year + '-' + mon + '-' + day + ' ' + hour + ':' + min + ':' + second
          return dateStr
        },
        show(data){
          this.isShow = true
          this.code = data
          this.listTable()
        },
        handleCancel(){
          this.isShow = false
          this.currentid = 0;
          this.id_jishi = 0
          this.pageOffset=1
        },
        handleOk(){
          if(this.currentid!==0){
            util.http.post('/api/tqtAuthentications/changeCorporate', {
              userId:this.currentid,
              unifiedSocialCreditCode:this.code
            }).then(res=>{
              if(res.data.code ===200){
                this.$Notice.success({title:'变更成功'})
                this.handleCancel()
                this.$emit('updateData')

              } else {
                this.$Notice.error({title:'变更失败'})
              }
            }).catch(err=>{
              this.$Notice.error({title:'变更失败'})

            })
          } else {
            this.$Notice.error({
              title:'请先选择法人'
            })
          }

        },
        listTable () {
          let _this = this
          _this.loading = true
          util.http
            .post('/api/user/selectqyyh', {
              pageIndex: _this.pageOffset,
              pageSize: _this.pageLength,
              name: _this.searchParasm.name,
              phone: _this.searchParasm.phone,
            })
            .then(function (response) {
              _this.tableData = []
              let data = response.data
              _this.pageTotal = response.data.recordsTotal
              let list = data.data
              for (let i = 0; i < list.length; i++) {
                let map = {
                  order: i + 1,
                  id: list[i].id,
                  name: list[i].name,
                  phone: list[i].phone,
                  password: list[i].password,
                  sfz: list[i].sfz,
                  email: list[i].email,
                  address: list[i].address,
                  pic: list[i].pic,
                  isrealauth: list[i].isrealauth,
                  idCardFrontPic: list[i].idCardFrontPic,
                  idCardBackPic: list[i].idCardBackPic,
                  sex: list[i].sex,
                  createTime: list[i].createTime,
                }
                _this.tableData.push(map)
              }
              _this.loading = false
            })
            .catch(function (error) {
              console.log(error)
              _this.loading = false
            })
        },
        //查询
        search () {
          this.pageOffset = 1
          this.listTable()
        },
        handlePageChange (current) {
          this.pageOffset = current
          this.listTable()
        },
      }

    }
</script>

<style scoped>

  .page-area {
    display: flex;
    justify-content: flex-end;
    padding-top: 35px;
    padding-right: 50px;
  }
</style>
